import { precoDaOpcao } from "../../utils/precoEtapas";

// Resumo das escolhas de um item da sacola (etapas, sabores, adicionais), com
// foto, nome e valor de cada escolha. Saiu de dentro do CardapioPublico.js
// (01/10/2026) para a sacola do popup (celular) e a da lateral (computador)
// mostrarem exatamente a mesma coisa.
//
// Três formatos de item chegam aqui, por ordem de prioridade:
//   1. adicionado pelo popup do produto — step_selections + order_steps
//   2. pizza (e todo item com subitems tipados por step_name)
//   3. "Peça de novo" — etapas já desnormalizadas, só com nomes

function escolhaDoPopup(step, itemId, produtos, qty) {
  const stepItem = step.items?.find((i) => i.product_id === itemId) || {};
  const fullProd = produtos.find((p) => p.id === itemId) || {};
  // Incluso grátis (price_override 0) sai "Grátis", não o preço do produto (achado 361)
  const price = precoDaOpcao(step, stepItem, fullProd);
  return {
    id: itemId,
    name: stepItem.product_name || fullProd.name || "",
    photo_url: stepItem.photo_url || fullProd.photo_url || null,
    price,
    gratis: price === 0,
    qty,
  };
}

function porEtapasDoPopup(item, produtos) {
  const summary = [];
  // Índice ABSOLUTO como chave (v1.5.396) — mesma convenção do popup.
  const relevantSteps = item.order_steps
    .map((step, absIndex) => ({ ...step, _absIndex: absIndex }))
    // combo_only só entra quando o item É combo (v1.5.396)
    .filter((step) => (step.combo_only ? item.combo_type === "combo" : true));
  relevantSteps.forEach((step) => {
    const selectedItems = item.step_selections[step._absIndex] || [];
    if (selectedItems.length === 0) return;
    const counts = {};
    const order = [];
    selectedItems.forEach((id) => {
      if (counts[id] === undefined) order.push(id);
      counts[id] = (counts[id] || 0) + 1;
    });
    const detailedItems = order
      .map((itemId) => escolhaDoPopup(step, itemId, produtos, counts[itemId] || 1))
      .filter((x) => x.name);
    if (detailedItems.length > 0) summary.push({ stepName: step.name, items: detailedItems });
  });
  return summary;
}

function porSubitems(item, produtos) {
  const grouped = {};
  const order = [];
  item.subitems.forEach((si) => {
    const k = (si.step_name && String(si.step_name).trim()) || "Adicionais";
    if (grouped[k] === undefined) { grouped[k] = []; order.push(k); }
    grouped[k].push(si);
  });
  return order.map((name) => ({
    stepName: name,
    items: grouped[name].map((si, idx) => {
      const lookup = si.product_id ? produtos.find((p) => String(p.id) === String(si.product_id)) : null;
      return {
        id: si.product_id || `${name}-${idx}`,
        name: si.nome || si.name || "",
        photo_url: si.photo_url || lookup?.photo_url || null,
        price: si.preco != null ? Number(si.preco) : (si.price != null ? Number(si.price) : null),
        qty: si.quantidade || si.qty || 1,
      };
    }).filter((x) => x.name),
  })).filter((s) => s.items.length > 0);
}

function porEtapasSalvas(item, produtos) {
  return item.etapas.map((etapa) => {
    // Aceita tanto 'itens' (salvo no backend) quanto 'items' (retrocompat)
    const names = Array.isArray(etapa.itens) ? etapa.itens : Array.isArray(etapa.items) ? etapa.items : [];
    const stepName = etapa.etapa || etapa.stepName || "";
    // Agrupa duplicados por nome mantendo ordem
    const counts = {};
    const order = [];
    names.forEach((n) => {
      if (counts[n] === undefined) order.push(n);
      counts[n] = (counts[n] || 0) + 1;
    });
    const detailedItems = order.map((nm) => {
      const prod = produtos.find((p) => (p.name || "").toLowerCase() === String(nm || "").toLowerCase());
      return {
        id: prod?.id || nm,
        name: nm,
        photo_url: prod?.photo_url || null,
        price: prod?.sale_price ?? prod?.simple_price ?? null,
        qty: counts[nm] || 1,
      };
    }).filter((x) => x.name);
    return { stepName, items: detailedItems };
  }).filter((s) => s.items.length > 0);
}

export function resumoEtapas(item, produtos = []) {
  if (item.step_selections && item.order_steps) {
    const summary = porEtapasDoPopup(item, produtos);
    if (summary.length > 0) return summary;
  }
  if (Array.isArray(item.subitems) && item.subitems.length > 0) {
    const summary = porSubitems(item, produtos);
    if (summary.length > 0) return summary;
  }
  if (Array.isArray(item.etapas) && item.etapas.length > 0) return porEtapasSalvas(item, produtos);
  return [];
}

// O lápis de "editar" só aparece quando o item tem algo para reabrir no popup.
export function itemEditavel(item) {
  return !!(item.combo_type || item.observation
    || (item.step_selections && Object.keys(item.step_selections).length > 0)
    || (Array.isArray(item.etapas) && item.etapas.length > 0));
}
